import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import Moment from 'moment';
import Recaptcha from 'react-google-invisible-recaptcha';

import TranslatedCopy from '../../intl/translated-copy';
import { CLIENT_KEY } from '../../constants/captcha-key';
import { sendAnalytics } from '../../analytics/tracker';
import registerCPTracking from '../../analytics/creators/manage';
import LoadingScreen from '../global/loading-screen';

import Button from '../global/button';

import { retrieveIpAddress, retrieveSessionTM } from '../../../redux/actions/index';
import { getContactabilityTokenData, userSignInAction } from '../../../redux/actions';
import { metricaSignUp } from '../../utilities/metricas-login';

const mapStateToProps = state => ({
  pnrCode: state.Manage.pnrInfo.pnrCode,
  sessionID: state.ProfileLogin.sessionID,
  touchPointType: state.TouchPointCpProperty.touchPointType,
  sourceOpenModalLogin: state.openModalLogin.sourceOpenModalLogin,
});
class UserProfileSuccessRegistration extends PureComponent {
  static propTypes = {
    contentForm: PropTypes.object,
    dispatch: PropTypes.func,
    isSignInLoading: PropTypes.bool,
    storefront: PropTypes.string,
    userProfileCPNumber: PropTypes.string,
  }

  componentDidMount() {
    const {
      contentForm,
      dispatch,
      ipAddress,
      sourceOpenModalLogin,
      storefront,
      touchPointType,
      userProfileCPNumber,
    } = this.props;

    dispatch(retrieveSessionTM());

    if (!ipAddress) {
      dispatch(retrieveIpAddress());
    }

    dispatch(sendAnalytics({
      eventCreator: registerCPTracking.userProfileRegistrationOtp('step 3', 'registro exitoso'),
    }));

    this.promocode = new URLSearchParams(window.location.search);
    const adnCodeFromUrl = this.promocode.get('referred_adn');
    this.adnCode = adnCodeFromUrl && adnCodeFromUrl !== null ? String(adnCodeFromUrl) : null;

    if (sourceOpenModalLogin) {
      metricaSignUp(dispatch, sourceOpenModalLogin, this.adnCode);
    }

    if (contentForm) {
      const registerUserSuccess = {
        clubPremierID: userProfileCPNumber, // Dynamic Data
        country: contentForm.countryCode, // Dynamic Data
        EdadProfile: contentForm.birthdayDate, // Dynamic Data
        profGender: contentForm.gender.toggle, // Dynamic Data
        storefront: storefront,
        touchPoint: touchPointType,
        yearProfile: contentForm.birthdayDate, // Dynamic Data
      };

      dispatch(sendAnalytics({
        eventCreator: registerCPTracking.registerCPTracking(registerUserSuccess),
      }));
    }

    this.contactability();
  }

  render() {
    const {
      loadingPorfileRequestStart,
      userProfileCPNumber,
    } = this.props;

    const formClass = cx({
      'UserProfileSignup-form--cp': true,
      'UserProfileSignup-form--loading': loadingPorfileRequestStart,
      'SignUpSucessForm-cp': true,
    });

    return (
      <section className={ formClass }>
        <div className='SignUpHeaderCp-statusIcon ConfirmationHeader-statusIcon--accepted Icon Icon--check'></div>
        <h3 className='SignUpSucessFormCp-Header'>
          <TranslatedCopy copyID='USER_PROFILE_SUCCESS_SIGNUP' />
        </h3>
        <p className='SignUpSuccessCp-CP'>
          <TranslatedCopy copyID='USER_PROFILE_NUMERO_CP' />
        </p>
        <h4 className='SignUpSuccessCp-NumeroCP'>
          <span>{ userProfileCPNumber } </span>
        </h4>
        <div className='SignUpFooterCp-Btn'>
          <Button
            btnType='submit'
            copyID='APP_LOGIN'
            filledRed={ true }
            onBtnClick={ this.handleLocalOnCLick }
          />
          <div >
            <Recaptcha
              ref={ ref => this.recaptcha = ref }
              sitekey={ CLIENT_KEY }
              onResolved={ this.handleSignIn } />
          </div>
        </div>
        <p className='SignUpSuccessCp-AvisoRecaptcha'>
          <TranslatedCopy copyID='PRO_HOME2.0_NOTICE_RECAPTCHA' />
        </p>
        { loadingPorfileRequestStart &&
          <LoadingScreen
            seatmap={ true }
            isDataLoading={ true }
            type='airplaneWindow' /> }
      </section>
    );
  }

  handleLocalOnCLick = () => {
    if (this.recaptcha && this.recaptcha.execute) {
      this.recaptcha.execute();
    }
  }

  handleSignIn = () => {
    const captchaResponse = this.recaptcha.getResponse();

    if (captchaResponse) {
      const {
        contentForm,
        dispatch,
        ipAddress,
        sessionID,
        userProfileCPNumber,
      } = this.props;

      const password = contentForm.SignUpPassword;

      dispatch(userSignInAction(userProfileCPNumber, '', password, sessionID, '', ipAddress));
    }
  }

  contactability = () => {
    const { 
      contentForm,
      dispatch,
      pnrCode,
      userProfileCPNumber,
    } = this.props;

    const contactability = [];
    const contactabilityMomentDate = Moment();
    const contactabilityDate = contactabilityMomentDate.format('YYYY-MM-DD');
    const contactabilityHour = contactabilityMomentDate.format('HH:mm:ss');

    if (contentForm) {
      const ageInMonths = Moment().diff(Moment(contentForm?.birthdayDate, 'YYYY-MM-DD'), 'months');

      let paxType = '';

      if (ageInMonths < 24) 
        paxType = 'INFANT';
      else if (ageInMonths >= 24 && ageInMonths < 144)
        paxType = 'CHILD';
      else
        paxType = 'ADULT';

      contactability.push({
        'avisoPrivacidad': '1',
        'correo': contentForm?.email,
        'fecha': contactabilityDate,
        'fechaNacimiento': contentForm?.birthdayDate,
        'ffn': userProfileCPNumber,
        'flujo': 'PROFILE',
        'hora': contactabilityHour,
        'nombre': `${ contentForm?.firstName } ${ contentForm?.lastName }`,
        'paisResidencia': contentForm?.countryCode,
        'paso': 'Register',
        'pnr': pnrCode ? pnrCode : 'SINPNR',
        'telefono': contentForm?.phone?.phoneNumber,
        'ticket': '0',
        'tipoPasajero': paxType,
      });
    }

    dispatch(getContactabilityTokenData(contactability));
  }
}

UserProfileSuccessRegistration = connect(mapStateToProps)(UserProfileSuccessRegistration);

export default UserProfileSuccessRegistration;